<span *ngIf="!onEdit">{{slug}}</span>
<div *ngIf="onEdit" fxLayoutGap="2px">
  <mat-progress-bar *ngIf="searching" [mode]="'indeterminate'"></mat-progress-bar>
  <div>
    <mat-form-field fxFlex="70">
      <input matInput
             [maxlength]="MAX_LENGTH"
             [(ngModel)]="model"
             matTooltip="Saisir un nom / libellé, celui-ci sera transformé en un raccourci lisible par le navigateur pour accéder au formulaire par les demandeurs"
             placeholder="saisir un libellé, il sera transformé en raccourci pour le lien">
      <div fxLayoutAlign="end"><mat-hint><code>{{model?.length}} / {{MAX_LENGTH}}</code></mat-hint></div>
    </mat-form-field>
    <button (click)="save()"
            [disabled]="!model"
            mat-icon-button
            matTooltip="obtenir le raccourci et enregistrer"
            color="accent">
      <mat-icon data-cy="icon-edit-slug-in-place-save">save</mat-icon></button>
    <button (click)="cancel()"
            mat-icon-button
            matTooltip="abandonner"
            color="warn">
      <mat-icon data-cy="icon-edit-slug-in-place-cancel">cancel</mat-icon></button>
  </div>
</div>
<button *ngIf="!onEdit"
        (click)="goEdit()"
        mat-icon-button
        class="small-icon-button"
        matTooltip="éditer le raccourci"
        color="accent"><mat-icon>edit</mat-icon></button>
